import axios from "axios";
import { REACT_APP_API } from "../constants";
import { checkAPISuccess, manageServiceError } from "../utils/helpers";
import { requestsFor } from "./headerService";

const axiosInstance = axios.create({
  baseURL: `${REACT_APP_API}/api/v1/databaseService`,
});

export const appAxios = axiosInstance

const path = {
  listDatabases: "/listDatabase",
  listUser: "/listUser",
  hostList: "/listUniqueHosts",
  tableFields: "/getTableFields",
  tableList: "/getTableNames",
};

const requests = requestsFor(axiosInstance);

export async function getDatabaseHostList({ payload, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.hostList, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Failed to fetch databases");
  }
}


export async function getTableLists({ payload, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.tableList, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Failed to fetch databases");
  }
}

export async function getTableFields({ payload, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.tableFields, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Failed to fetch table fields");
  }
}

export async function getDatabasesList({ payload, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.listDatabases, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Failed to fetch databases");
  }
}


export async function getDatabaseUsersList({ payload, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.listUser, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Failed to fetch database users");
  }
}